import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { AddeditSiteComponent } from '../addedit-site/addedit-site.component';

@Component({
  selector: 'app-market-dialog',
  standalone: true,
  imports: [FormsModule, CommonModule, MatButtonModule, AddeditSiteComponent],
  templateUrl: './site-dialog.component.html',
  styleUrls: ['./site-dialog.component.scss'],
})
export class SiteDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<SiteDialogComponent, any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder
  ) {}
  siteFormData: any;
  ngOnInit() {
    if (!this.data || !this.data?.formData) {
    }
  }
  onNoClick(): void {
    this.dialogRef.close({ submitted: false });
  }

  onSaveClick(): void {
    this.dialogRef.close({ submitted: true, data: this.siteFormData });
  }
  onFormSubmit(data: any) {
    if (data.submit == false) {
      this.dialogRef.close({ submitted: false });
    } else {
      this.siteFormData = data;
      this.onSaveClick();
      console.log('onFormSubmit', data);
    }
  }
}
